import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { LandingSection } from './LandingSection'
import { FREE_PLAN } from '../../content/planMarketing'
import { landingLinkClass } from './landingLinkStyles'

export function LandingCta() {
  return (
    <LandingSection
      title="Start monitoring in minutes"
      subtitle={`Create a free account, add up to ${FREE_PLAN.monitors} monitors, connect Slack or email alerts, and publish a public status page. No credit card required.`}
      centered
      className="pb-24"
    >
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link to="/signup" className={clsx(landingLinkClass('primary', 'md'), 'px-5')}>
          Start Free
        </Link>
        <Link to="/pricing" className={landingLinkClass('ghost', 'md')}>
          View pricing
        </Link>
      </div>
    </LandingSection>
  )
}
